import React, {Component} from 'react';
import {Button, Modal, ModalHeader, ModalBody, ModalFooter, Input} from 'reactstrap';
import {toast} from 'react-toastify';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import {isEmpty} from 'lodash';

import EditTimeSheetConfirmDeleteModal from './editTimeSheetConfirmDeleteModal';
import ErrorMsg from "../common/ErrorMsg";
import DailyAttendanceService from "../../services/DailyAttendanceService";


export default class EditTimeSheet extends Component {
    state = {
        timeSheet: [],
        staffList: [],
        selectedStaff: 0,
        showWorkDate: false,
        workDate: '',
        showTimeSheet: false,
        timeSheetErrors: [],
        needToAdd: false,
        timeTemp: "",
        selectedStaffUseMidnight: false,
        showEditTimeSheetConfirmDeleteModal: false,
        timeSheetToBeDeletedId: 0,
    };

    componentDidMount = () => {
        if (this.props.agencyLocation) {
            this.getInitialState();
        }
    };

    getInitialState = async () => {
        if (this.props.isEnableStaffSelection) {
            try {
                const result = await DailyAttendanceService.getStaffList(
                    this.props.agencyLocation
                );
                if (200 === result.status) {
                    console.log(result.data);
                    let staffList = result.data.user.map((staff) => ({...staff}));
                    console.log(staffList);
                    this.setState({staffList});

                }
            } catch (error) {
                toast.error(<ErrorMsg errors={error.response}/>);
            }
        } else {
            const selectedUser = {...this.props.selectedUser};
            this.setState({selectedStaff: selectedUser.id, showWorkDate: true});
        }
        
        try {
            await this.props.getReasons(this.props.agencyLocation);
        } catch (error) {
            toast.error(<ErrorMsg errors={error}/>, {autoClose: 5000});
        }
    };

    userChangeHandler = (event) => {
        let selectedStaff = event.currentTarget.value;
    
        // seting use midnight for selected staff.
        let selectedStaffUseMidnight  = false;
        this.state.staffList.forEach(staff => {
            if (staff.id===Number(selectedStaff)) {
                selectedStaffUseMidnight = staff.use_midnight_checkout;
                return;
            }
        });

        if (selectedStaff > 0) {
            this.setState({
                selectedStaff, showWorkDate: true, workDate: '', 
                showTimeSheet: false, timeSheet: [],
                selectedStaffUseMidnight:selectedStaffUseMidnight,
            });
        }
    };

    handleDateChange = (date) => {
        this.setState({workDate: date, showTimeSheet: true}, () => {this.getTimeSheet()});
    };

    getTimeSheet = async () => {
        let {selectedStaff, workDate} = this.state;
        let workDateFormatted = moment(workDate).format("YYYY-MM-DD");
        try {
            await this.props.getUserTimeSheet(selectedStaff, workDateFormatted);
            let timeSheet = this.props.dailyAttendance.userTimesheet.map(sheet => {
                let updatedSheet = {...sheet};
                if (sheet.clock_in) {
                    updatedSheet.clock_in = moment(
                        `${sheet.clock_in}`, ["HH:mm:ss"]).format("hh:mm A");
                }
                if (sheet.clock_out) {
                    updatedSheet.clock_out = moment(
                        `${sheet.clock_out}`, ["HH:mm:ss"]).format("hh:mm A");
                }
                return updatedSheet;
            });
            if (timeSheet.length > 0) {
                this.setState({timeSheet, needToAdd: false});
            } else {
                timeSheet = [{
                    id: 0,
                    user: selectedStaff,
                    work_date: workDateFormatted,
                    clock_in: "",
                    clock_out: "",
                    clock_out_reason: ""
                }]
                this.setState({timeSheet, needToAdd: true});
            }
        } catch (error) {
            toast.error(<ErrorMsg errors={error}/>, {autoClose: 5000});
        }
    };

    addRow = () => {
        let {selectedStaff, workDate} = this.state;
        let workDateFormatted = moment(workDate).format("YYYY-MM-DD");
        let timeSheet = this.state.timeSheet.map(sheet => ({...sheet}));
        timeSheet.push({
            id: 0,
            user: selectedStaff,
            work_date: workDateFormatted,
            clock_in: "",
            clock_out: "",
            clock_out_reason: ""
        })
        this.setState({timeSheet});
    }

    toggleModal = (reload) => {
        this.setState({
            selectedStaff: 0,
            workDate: '',
            timeSheet: [],
            showTimeSheet: false,
            showWorkDate: false,
            timeSheetErrors: []
        }, () => this.props.toggleModal(reload));
    };

    handleChange = (index, name, value) => {
        let timeString = value.split(':').join('');
        timeString = timeString.split(' ').join('');
        let hour = Number(timeString.substring(0,2)) < 13 ? String(timeString.substring(0,2)) : '12';
        hour = Number(hour) > 1 && Number(hour) < 10 ? ("0"+hour).slice(-2) : hour;
        let mint = Number(timeString.substring(2,4)) < 59 ? String(timeString.substring(2,4)) : '59';
        mint = Number(mint) > 5 && Number(mint) < 10 ? ("0"+mint).slice(-2) : mint;
        let am_pm = '';
        if (timeString.substring(4,6).length === 1) {
            if (['A', 'P'].indexOf(timeString.substring(4,5).toUpperCase()) > -1) {
                am_pm = String(timeString.substring(4,6).toUpperCase());
            } else {
                am_pm = 'A';
            }
        } else if (timeString.substring(4,6).length === 2) {
            if (['AM', 'PM'].indexOf(timeString.substring(4,6).toUpperCase()) > -1) {
                am_pm = String(timeString.substring(4,6).toUpperCase());
            } else {
                if (timeString.substring(4,5).toUpperCase() === 'A') {
                    am_pm = 'AM'; 
                } else if (timeString.substring(4,5).toUpperCase() === 'P') {
                    am_pm = 'PM'; 
                } else {
                    am_pm = 'AM';
                }
            }
        }

        let newtimeSheet = this.state.timeSheet.map((sheet) => ({...sheet}));

        if (timeString.length === 0) {
            newtimeSheet[index][name] =  ``;
        } else if (timeString.length <= 2) {
            if (value === `${hour}:`) {
                newtimeSheet[index][name] = `${("0"+hour).slice(-2)}:`;
            } else {
                newtimeSheet[index][name] =  `${hour}`;
            }
        } else if (timeString.length <= 4) {
            if (value === `${hour}:${mint} `) {
                newtimeSheet[index][name] = `${hour}:${("0"+mint).slice(-2)} `;
            } else {
                newtimeSheet[index][name] = `${hour}:${mint}`;
            }
        } else {
            newtimeSheet[index][name] =  `${hour}:${mint} ${am_pm}`;
        }

        this.setState({timeSheet: newtimeSheet});
    };

    handleReasonChanges = (index, e) => {
        const reasonId = e.currentTarget.value;
        let newtimeSheet = this.state.timeSheet.map((sheet) => ({...sheet}));
        newtimeSheet[index]['clock_out_reason'] =  reasonId;
        this.setState({timeSheet: newtimeSheet});
    }

    validateTimeSheetAndSubmit = () => {
        let timeSheet = [];
        this.state.timeSheet.map((sheet) => {
            if (sheet.clock_in || sheet.clock_out) {
                let updatedSheet = {...sheet};
                if (updatedSheet.clock_in) {
                    updatedSheet['clock_in'] = moment(
                        `${updatedSheet.clock_in}`, ["h:mm A"]).format("HH:mm:ss");
                }
                if (updatedSheet.clock_out) {
                    updatedSheet['clock_out'] = moment(
                        `${updatedSheet.clock_out}`, ["h:mm A"]).format("HH:mm:ss");
                }
                timeSheet.push(updatedSheet);
            }
        });
        let timeSheetErrors = [], error = false;

        timeSheet.map((sheet, index) => {
            timeSheetErrors[index] = {};
            if (!(sheet.clock_in && sheet.clock_in !== "Invalid date")) {
                timeSheet[index]['clock_in'] = null;
            }
            if (!(sheet.clock_out && sheet.clock_out !== "Invalid date")) {
                timeSheet[index]['clock_out'] = null;
                timeSheet[index]['clock_out_reason'] = "";
            }
            if (sheet.clock_in && sheet.clock_out) {
                if (!sheet.clock_out_reason) {
                    timeSheetErrors[index]['clock_out_reason'] = "Reason is required.";
                    error = true;
                }

                // adding the condition for midnight functionality.... 

                // if midnight is on for the user skip this validation... 
                if (!this.state.selectedStaffUseMidnight && (moment(sheet.clock_out, ["HH:mm:ss"]) < moment(sheet.clock_in, ["HH:mm:ss"]))) {
                    console.log(this.state.selectedStaff);
                    const errMsg = "Clock-Out time should be greater than the clock-in time.";
                    timeSheetErrors[index]['clock_out'] = errMsg;
                    error = true;
                }
            }
            if (isEmpty(sheet.clock_in)) {
                timeSheetErrors[index]['clock_in'] = "Clock-In is required.";
                error = true;
            }
            if (isEmpty(sheet.clock_out) && (timeSheet.length > index+1) && timeSheet[index+1].clock_in) {
                timeSheetErrors[index]['clock_out'] = "Clock-Out is required.";
                error = true;
            }
        });



        this.setState({timeSheetErrors}, () => {
            if (error === false) {
                this.saveTimeSheet(timeSheet);
            }
        });
    };

    deleteTimesheetShowModal =  (timeSheetId) => {
         this.setState({timeSheetToBeDeletedId:timeSheetId});
         this.setState({showEditTimeSheetConfirmDeleteModal:true});
    }
    
    deleteTimesheet = async () => {
        const timeSheetId = this.state.timeSheetToBeDeletedId;
        let timeSheet =  this.state.timeSheet.filter(sheet => sheet.id != timeSheetId);
        if (isEmpty(timeSheet)){
            timeSheet = [{
                id: 0,
                user: this.state.selectedStaff,
                work_date: this.state.workDateFormatted,
                clock_in: "",
                clock_out: "",
                clock_out_reason: ""
            }]
        }
        this.setState({timeSheet});
        try{
            await this.props.deleteUserTimesheet(timeSheetId);
            toast.success("Deleted Successfully.");
        }
        catch (error){
            toast.error(<ErrorMsg errors={error}/>, {autoClose: 5000});
        }
        this.toggleConformDeleteTimeSheetModal();
    }

    saveTimeSheet = async (timeSheet) => {
        let {selectedStaff, workDate, needToAdd} = this.state;
        let workDateFormatted = moment(workDate).format("YYYY-MM-DD");
        if (timeSheet.length > 0) {
            try {
                await this.props.updateUserTimeSheet(
                    selectedStaff, workDateFormatted, timeSheet, needToAdd
                );
                toast.success("Saved Successfully.");
                this.toggleModal(true);
            } catch (error) {
                toast.error(<ErrorMsg errors={error}/>, {autoClose: 5000});
            }
        } else {
            toast.error("No data to save.");
        }
    };

    handleDateChangeRaw = (e) => {
        e.preventDefault();
    };

    toggleConformDeleteTimeSheetModal = () => {
        this.setState({showEditTimeSheetConfirmDeleteModal: !this.state.showEditTimeSheetConfirmDeleteModal});
    };


    render() {
        const {
            timeSheet, staffList, showWorkDate, workDate, selectedStaff, 
            showTimeSheet, timeSheetErrors
        } = this.state;
        let timesheetData = [], staffListOption, reasons = [];

        if (!(isEmpty(staffList))) {
            staffListOption = staffList.map((list, index) =>
                <option key={index} data-useMidnight = {list.use_midnight_checkout} value={list.id}>{list.full_name}</option>
            );
        }

        if (!(isEmpty(this.props.dailyAttendance.reasons))) {
            reasons = this.props.dailyAttendance.reasons.map((reason, index) => 
                <option key={index}  value={reason.id}>{reason.reason}</option>
            );
        }
        
        if (!(isEmpty(timeSheet))) {
            timeSheet.map((sheet, index) => {
                timesheetData.push(             
                    <div key={index} className="row mb-2">
                        <div className="col-sm-4">
                            <Input type="text" className="text-center" 
                                placeholder="HH:MM AM/PM"  value={sheet.clock_in} 
                                onChange={(event) => {
                                    this.handleChange(index, "clock_in", event.target.value)}} 
                            />
                            <span className="text-danger">
                                {!(isEmpty(timeSheetErrors[index])) && 
                                    !(isEmpty(timeSheetErrors[index]['clock_in'])) ? 
                                        timeSheetErrors[index]['clock_in'] : ''}
                            </span>
                        </div>
                        <div className="col-sm-4">
                            <Input type="text" className="text-center" 
                                placeholder="HH:MM AM/PM" value={sheet.clock_out} 
                                onChange={(event) => {
                                    this.handleChange(index, "clock_out", event.target.value)}} 
                            />
                            <span className="text-danger">
                                {!(isEmpty(timeSheetErrors[index])) && 
                                    !(isEmpty(timeSheetErrors[index]['clock_out'])) ? 
                                        timeSheetErrors[index]['clock_out'] : ''}
                            </span>
                        </div>
                        <div className="col-sm-3">
                            <select name="clock_out_reason" className="form-control"
                                onChange={(e) => {this.handleReasonChanges(index, e)}}
                                value={sheet.clock_out_reason}
                            >
                                <option key={-1} value="">Select a reason</option>
                                {reasons}
                            </select>
                            <span className="text-danger">
                                {!(isEmpty(timeSheetErrors[index])) && 
                                    !(isEmpty(timeSheetErrors[index]['clock_out_reason'])) ? 
                                        timeSheetErrors[index]['clock_out_reason'] : ''}
                            </span>
                        </div>
                        { sheet.id != 0 &&
                            <div className="col-sm">
                                <i id={sheet.id} className="fa fa-trash-o pt-2 text-danger" onClick={(event) => this.deleteTimesheetShowModal(event.target.id)}/>
                            </div>
                        }
                    </div>
                );
            });
        }
        
        return (
            <Modal isOpen={this.props.modal} toggle={() => {this.toggleModal(false)}}>
                <ModalHeader toggle={() => {this.toggleModal(false)}}>
                    Edit Timesheet
                </ModalHeader>
                <ModalBody>
                    <div className="row">
                        <div className="col-sm-6">
                        {this.props.isEnableStaffSelection ? 
                            <React.Fragment>
                                <label className="mb-0">Select Staff Name</label>
                                <select name="user_name" className="form-control"
                                        onChange={this.userChangeHandler}
                                        value={selectedStaff}>
                                    <option key="0" data-useMidnight={false} value="0">Select a staff</option>
                                    {staffListOption}
                                </select>
                            </React.Fragment>
                            :
                            <React.Fragment>
                                <label className="mb-0">Staff Name</label>
                                <input type="text" className="form-control" 
                                    value={this.props.selectedUser.full_name} disabled={true} />
                            </React.Fragment>
                        }
                            
                        </div>
                        {showWorkDate &&
                            <div className="col-sm-6">
                                <label className="mb-0">Select Date</label>
                                <div className="div-datepicker">
                                    <DatePicker
                                        selected={workDate}
                                        onChangeRaw={this.handleDateChangeRaw}
                                        onChange={(event) => this.handleDateChange(event)}
                                        dateFormat="MM/DD/YYYY"
                                        fixedHeight showMonthDropdown showYearDropdown
                                        dropdownMode="select" className="form-control"
                                        placeholderText="Work Date (MM/DD/YYYY)"
                                        minDate={moment('2012-01-01')}
                                        maxDate={moment()}
                                        className="form-control"
                                        autoComplete="off" list="autocompleteOff" 
                                    />
                                </div>
                            </div>
                        }
                    </div>
                    <hr />
                    <div className="row">
                        <div className="col-sm-4 text-center"><label>Clock In</label></div>
                        <div className="col-sm-4 text-center"><label>Clock Out</label></div>
                        <div className="col-sm-4 text-center"><label>Reason</label></div>
                    </div>
                    { 
                        showTimeSheet ? 
                            timeSheet.length > 0 ?
                                timesheetData
                            : <p>No Data Available</p>
                        :
                        null
                    }
                </ModalBody>
                <ModalFooter>
                    { showTimeSheet ?
                        <React.Fragment>
                            <Button className="btn btn-info" onClick={this.addRow}>Add Row</Button>
                            <Button className='btn btn-success' 
                                onClick={this.validateTimeSheetAndSubmit}>Save</Button>
                        </React.Fragment>
                        : null
                    }
                    <Button className='btn btn-secondary' 
                        onClick={() => {this.toggleModal(false)}}>Close</Button>
                </ModalFooter>
                {this.state.showEditTimeSheetConfirmDeleteModal &&
                    <EditTimeSheetConfirmDeleteModal {...this.props} modal={this.state.showEditTimeSheetConfirmDeleteModal}
                        toggleModal={this.toggleConformDeleteTimeSheetModal}
                        messageTitle="Delete timesheet entry"
                        messageBody="Are you sure you want to delete this timesheet entry"
                        deleteTimesheet={this.deleteTimesheet}
                        timeSheetId={this.state.timeSheetToBeDeletedId}
                    />
                }
            </Modal>
            
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/daliyAttendance/editTimeSheet.js